import { Text } from "react-native-paper";
import Box from "../Box";
import { LEGEND_DIMENSIONS, SPACING, TEXT_VARIANTS } from "./constants";
import type { LegendItem } from "./types";

type DataLegendProps = {
	items: LegendItem[];
};

export const DataLegend = ({ items }: DataLegendProps) => {
	return (
		<Box
			flexDirection="row"
			flexWrap="wrap"
			gap={SPACING.legend}
			paddingHorizontal={SPACING.card}
			justifyContent="center"
		>
			{items.map((item, index) => {
				const type = item.type ?? "badge";
				const isBadge = type === "badge";
				const isIcon = type === "icon";

				return (
					<Box
						key={`${item.label}-${index}`}
						flexDirection="row"
						alignItems="center"
						gap={LEGEND_DIMENSIONS.itemGap}
					>
						{isBadge && (
							<Box
								style={{
									width: LEGEND_DIMENSIONS.badgeSize,
									height: LEGEND_DIMENSIONS.badgeSize,
									borderRadius: LEGEND_DIMENSIONS.badgeBorderRadius,
									backgroundColor: item.color,
								}}
							/>
						)}
						{isIcon && item.icon && (
							<Box
								style={{
									width: LEGEND_DIMENSIONS.iconSize,
									height: LEGEND_DIMENSIONS.iconSize,
								}}
							>
								{item.icon}
							</Box>
						)}
						<Text variant={TEXT_VARIANTS.legend}>{item.label}</Text>
					</Box>
				);
			})}
		</Box>
	);
};
